// extracted by mini-css-extract-plugin
module.exports = {"description":"IdealCard_description__2kazn"};